import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './redux/store';

import { AnalyticsProvider } from './components/AnalyticsProvider/AnalyticsProvider';

import './i18n';

// import LoaderLine from './components/Loaders/LoaderLine/LoaderLine';

import * as Tooltip from '@radix-ui/react-tooltip';

import './index.scss';
// import './index.css'


import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://4a9b50def06e8976ba9d66927900acfa@o4510482129485824.ingest.us.sentry.io/4510482131910656",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <AnalyticsProvider>
                    <Tooltip.Provider>
                        <App />
                        <div id="overlay-root" />
                    </Tooltip.Provider>
                </AnalyticsProvider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
)
